<template>
  <div class="frame" :style="{height:params.frameHeight+'px', width: params.frameWidth+'px'}">
    <img :src="imgSrc" style="width:100%">
    <a-spin class="loading" size="large" tip="正在加载..." v-show="loading" />
  </div>
</template>

<script>
import projectModel from '@/api/project'
export default {
  components: {

  },
  props: {
    params: {
      type: Object,
      required: true,
      default: function () {
        return {
          img: '',
          cropX: 0,
          cropY: 0,
          cropW: 0,
          cropH: 0,
          frameX: 0,
          frameY: 0,
          frameWidth: 0,
          frameHeight: 0,
          colorX: 0,
          colorY: 0
        }
      }
    }
  },
  data () {
    return {
      imgSrc: '',
      loading: false
    }
  },
  created () {
    // this.update()
  },
  methods: {
    update () {
      this.loading = true
      projectModel.preview(this.params).then(res => {
        this.imgSrc = URL.createObjectURL(res)
        this.loading = false
      }, _ => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.frame{background:#fff; position: relative; margin: 0 auto;box-shadow:0 0 20px #ccc;}
.loading{position: absolute;bottom:50%;left:50%;}
</style>



// WEBPACK FOOTER //
// src/pages/design/PreviewR.vue